import { Suspense } from "react";

import AppFlow from "./AppFlow";

export const Router = (): JSX.Element => (
	<Suspense fallback={<></>}>
		<div className="flex flex-col w-screen h-full md:flex-row md:h-screen">
			<AppFlow />
		</div>
	</Suspense>
);
